import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserAuthIcon } from '~/components/user-auth-icon';
import { useNumFormatter } from '~/utils/format/num-formatter';
import { Image } from '~/components/image';
import _get from 'lodash/get';
import { Link } from '@remix-run/react';

import './style.scss';

const UserLineCard: React.FC<{
  userAuthInfo?: string;
  name: string;
  desc: string;
  icon_url: string;
  aHref: string;
  className?: string;
  style?: any;
  onClick?: any;
  showNumber?: boolean;
  followerCount?: number;
}> = (props) => {
  const {
    userAuthInfo = '',
    name = '',
    desc = '',
    icon_url = '',
    className = '',
    style = {},
    aHref,
    onClick = () => {
      //
    },
    showNumber = false,
    followerCount,
  } = props;

  const { t } = useTranslation();

  const formatNum = useNumFormatter();

  return (
    <Link to={aHref} className={`user-card ${className}`} style={style} onClick={onClick}>
      <Image className="user-card-avatar" src={icon_url} alt={t('own_picture').replace('%s', name)} />

      <div className="user-card-content">
        <div className="user-card-content-name">
          <h2 className="user-card-content-name-text">{name}</h2>
          <UserAuthIcon
            authInfo={{
              showAuthSymbol: _get(userAuthInfo, 'show_auth_symbol', false),
              authType: _get(userAuthInfo, 'auth_type', 0),
            }}
            width="16px"
            height="16px"
            marginLeft="4px"
          />
        </div>
        <div className="user-card-content-desc">{desc}</div>
        {showNumber && followerCount !== undefined && (
          <div className="user-card-content-number">
            <span className="user-data-item-digit">{formatNum(followerCount)}</span>
            <span className="user-data-item-text ">{t('fans_count_number')}</span>
          </div>
        )}
      </div>
    </Link>
  );
};

export default UserLineCard;
